import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import { BootstrapVue3 } from 'bootstrap-vue-3'

// Font Awesome
// Удаляем импорты Font Awesome, так как теперь используем CDN версию
/*
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faCut, faIndustry, faCog, faWrench, faPhone, 
  faEnvelope, faMapMarkerAlt, faChevronRight,
  faLayerGroup, faBars, faTimes, faArrowRight,
  // Добавленные иконки
  faBolt, faBullseye, faShieldAlt, faHandshake,
  faCheckCircle, faInfoCircle, faCogs, faUserTie,
  faTools, faTruck, faSearch, faBriefcase,
  faClock, faThumbsUp, faGlobe, faFileAlt,
  faDraftingCompass, faChartLine
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
*/

// Animation on scroll
import AOS from 'aos'
import 'aos/dist/aos.css'

// Add icons to library
// Удаляем добавление иконок, так как используем CDN версию
/*
library.add(
  faCut, faIndustry, faCog, faWrench, faPhone, 
  faEnvelope, faMapMarkerAlt, faChevronRight,
  faLayerGroup, faBars, faTimes, faArrowRight,
  // Добавленные иконки
  faBolt, faBullseye, faShieldAlt, faHandshake,
  faCheckCircle, faInfoCircle, faCogs, faUserTie,
  faTools, faTruck, faSearch, faBriefcase,
  faClock, faThumbsUp, faGlobe, faFileAlt,
  faDraftingCompass, faChartLine
)
*/

// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true
})

const app = createApp(App)

// Register components globally
// Удаляем регистрацию компонента Font Awesome
// app.component('font-awesome-icon', FontAwesomeIcon)

// Use plugins
app.use(store)
app.use(router)
app.use(BootstrapVue3)

app.mount('#app')
